module.exports = "ng-select {\n  width: 100%; }\n\nbutton.btn-outline-success {\n  margin-top: 2rem; }\n\nbutton[disabled] {\n  cursor: not-allowed; }\n\n.form-control-custom-padding {\n  padding: 0.200rem 0.75rem; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/settings/bases/bases.component.scss
// module id = 579
// module chunks = 1